<template>
    <form @change="sendDataForSaving">
        <div class="row">
            <div class="col-md-12">
                <p>Please let us know your work history in the last five years starting with the most recent.</p>
            </div>
        </div>

        <WorkHistoryItem
            v-for="(work, index) in work_history"
            :work.sync="work"
            :states="states"
            :countries="countries"
            :key="index"
            :index="index"
            :is-active="index === activeHistory"
            @activate="activateHistory"
            @remove="deleteHistory(work.id)"
        ></WorkHistoryItem>

        <div class="mb-4 add-row text-right">
            <button class="add-link" @click.prevent="addForm">+ Add Previous Employment</button>
        </div>
    </form>

</template>

<script>
import WorkHistoryItem from "./WorkHistoryItem.vue";
import WorkHistoryService from "../services/WorkHistoryService";

export default {
    name: 'WorkHistoryForm',
    components: {WorkHistoryItem},
    emits: ['data-changed'],
    props: {
        states: {
            type: Array,
            required: true
        },
        user: {
            type: Object,
        },
        countries: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            work_history: [],
            activeHistory: 0
        }
    },
    mounted() {
        this.work_history = this.user.work_histories
    },
    methods: {
        addForm() {
            this.work_history.push({
                id: null,
                employer_name: null,
                employer_position: null,
                employer_city: null,
                start_day: null,
                end_day: null,
                is_working: false,
                starting_payment: null,
                ending_payment: null,
                reason_leaving: null,
                duties: null,
                direct_supervisor_name: null,
                employer_phone: null,
                contacting: null,
                state: null,
                country_id: null,
            })

            this.activeHistory = this.work_history.length - 1;
        },
        activateHistory(history) {
            this.activeHistory = history;
        },
        async deleteHistory(id) {
            this.work_history = this.work_history.filter((item) => item.id !== id)
            try {
                this.$showSuccessMessageDelete();
                await WorkHistoryService.deleteHistory(id);

            } catch (error) {
            }
        },
        sendDataForSaving() {
            let hasValues = false;

            for (const key in this.work_history) {
                if (this.work_history[key] !== null && this.work_history[key] !== undefined) {
                    hasValues = true;
                    break;
                }
            }

            if (hasValues) {
                this.$emit('data-changed', this.work_history);
            } else {
                this.$emit('data-changed', null);
            }
        },
    },
    watch: {
        work_history: {
            handler(newValue) {
                if (newValue.length === 0) {
                    this.addForm();
                }
            },
            deep: true,
        },
    },
}

</script>

<style scoped>

</style>
